import * as React from 'react';
import styled from 'styled-components';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@material-ui/core/AppBar';

const StyledAppBar = styled(MuiAppBar)``;

export type DSAppBarProps = MuiAppBarProps;
export const DSAppBar: React.FC<DSAppBarProps> = StyledAppBar;
